 import {createBrowserHistory} from 'history';
 
 
 export default createBrowserHistory({
	  basename: "/", // The base URL of the app (see below)
	  forceRefresh: true, // Set true to force full page refreshes
	  keyLength: 6, // The length of location.key
	  // A function to use to confirm navigation with the user (see below)
	  getUserConfirmation: (message, callback) => callback(window.confirm(message))
})


// WEBPACK FOOTER //
// ./src/history.js